export { default } from "-!./App.ts?vue&type=script&lang=ts&external"; export * from "-!./App.ts?vue&type=script&lang=ts&external"